import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class JwtStateService {
  
  private _jwt = signal<string | null>(null);
  readonly jwt = this._jwt.asReadonly();

  clearJwt() {
    this._jwt.set(null);
  }

  setJwt(jwt: string) {
    this._jwt.set(jwt);
  }
}
